import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useRegister } from '@games/api';
import { HelmetTitle } from '../helmet';
import messages from 'intl/messages';
import { RegisterForm, RegisterValues } from './RegisterForm';
import { selectAuthUser, setAuthUser } from './auth-slice';
import { useDispatch } from 'react-redux';

export const RegisterPage: React.FC = () => {
  const [{ data, loading, error }, register] = useRegister();
  const me = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (data && 'token' in data) {
      dispatch(setAuthUser(data));
    }
  }, [data, dispatch]);

  const submit = React.useCallback((data: RegisterValues) => {
    register({ data });
  }, [register]);

  if (me && me.token) {
    return (
      <div className='text-center'>
        <HelmetTitle message={formatMessage(messages.loggedIn)} />
        <FormattedMessage {...messages.loggedIn} />
      </div>
    );
  }

  return (
    <div className='container mx-auto'>
      <HelmetTitle message={formatMessage(messages.register)} />
      <h2 className='text-center text-2xl mb-4 font-bold'>
        <FormattedMessage {...messages.register} />
      </h2>
      <RegisterForm onSubmit={submit} loading={loading} />
      {error && (
        <div className='text-center'>
          <FormattedMessage {...messages.ajaxError} />
        </div>
      )}
      {data && 'error' in data && data.error === null && (
        <div className='text-center'>
          The username or email address is already in use.
        </div>
      )}
    </div>
  );
};
